export const gradients = [
    "bg-gradient-to-br from-white to-[#D3E4FD]/40",
    "bg-gradient-to-br from-white to-[#FEF7CD]/40",
    "bg-gradient-to-br from-white to-[#FFDEE2]/40", 
    "bg-gradient-to-br from-white to-[#F1F0FB]/40",
    "bg-gradient-to-br from-white to-[#FDE1D3]/40"
  ];